import A2HSProvider from './A2HSProvider';
export { withA2HS } from './themeContext';
export default A2HSProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/a2hs/es/index.js
// module id = 83
// module chunks = 28